import {createSelector} from '@reduxjs/toolkit';
import {CommonRootState} from '../types';

export type UserInfo = {
  firstName: string;
  lastName: string;
  email: string;
  isAdmin: boolean;
};

export const selectToken = (state: CommonRootState) => state.user.token;
export const selectIsLoggedIn = (state: CommonRootState) =>
  state.user.token !== null;
export const selectIsAdmin = (state: CommonRootState) => state.user.isAdmin;
export const selectUserEmail = (state: CommonRootState) => state.user.email;
export const selectHasUsablePassword = (state: CommonRootState) =>
  state.user.hasUsablePassword;
// `?? null`: a store persisted before the field existed rehydrates without it.
export const selectReauthMethods = (state: CommonRootState) =>
  state.user.reauthMethods ?? null;

const selectUserFirstname = (state: CommonRootState) => state.user.firstName;
const selectUserLastname = (state: CommonRootState) => state.user.lastName;

export const selectUserInfo = createSelector(
  selectUserFirstname,
  selectUserLastname,
  selectUserEmail,
  selectIsAdmin,
  (firstName, lastName, email, isAdmin): UserInfo => ({
    firstName,
    lastName,
    email,
    isAdmin,
  }),
);

export const getUserUsername = createSelector(
  selectUserFirstname,
  selectUserLastname,
  (firstName, lastName) => {
    return `${firstName} ${lastName}`;
  },
);

export const getDebugEmail = (state: CommonRootState) => state.user.debugEmail;

export const getDebugPremiumOverride = (state: CommonRootState) =>
  state.user.debugPremiumOverride;

export const getDebugLanguageOverride = (state: CommonRootState) =>
  state.user.debugLanguageOverride;

export const getDebugApiUrl = (state: CommonRootState) =>
  state.user.debugApiUrl;
